var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-info",staticStyle:{"background":"#c1c1c1"}},[_c('v-row',{staticStyle:{"background":"white","padding":"5px","border-radius":"5px","margin":"5px"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-row')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }